import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reportActions } from '../../store/reportStore'
import { Translate } from 'react-localize-redux';
import { withLocalize } from "react-localize-redux";
import classnames from 'classnames';
import ExcelExportButton from '../common/excelExportButton';
import HorizontalScrollControl from '../layoutItems/horizontalScrollControl';
import OldStyleSection from '../common/oldStyleSection';
import OldStyleTableWithHistory from '../common/oldStyleTableWithHistory';

import './finStatements/finStatements.scss';

const ROW_TYPES = {
    data: "data",
    marking: "marking"
}

class FinStatementsIfrsData extends React.Component {
    shouldComponentUpdate(nextProps, _) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? null : this.renderContent(this.props.data));
    }

    renderContent = (data) => {
        return (
            <>
                {Object.keys(data).filter(k => data[k].hasFinancialPositionRows || data[k].hasProfitAndLossRows || data[k].hasCashFlowRows).map((key, index) => <OldStyleSection
                    key={key} name={this.props.translate(`Report.FinancialStatementsIfrs.${key}`)} hasData isBold isOpen={index === 0}
                >
                    <div style={{ marginLeft: "2.5em", paddingTop: "0.25em" }}>
                        {data[key].hasFinancialPositionRows && this.renderSection("FinancialPositionIfrsStatement", `Report.FinancialStatementsIfrs.${key.includes('Original') ? 'Original.' : ''}FinancialPositionStatement`,
                            data[key].financialPositionRows, data[key].headerTypes, data[key].statements, false)}
                        {data[key].hasProfitAndLossRows && this.renderSection("ProfitAndLossIfrsStatement", `Report.FinancialStatementsIfrs.${key.includes('Original') ? 'Original.' : ''}ProfitAndLossStatement`,
                            data[key].profitAndLossRows, data[key].headerTypes, data[key].statements, true)}
                        {data[key].hasCashFlowRows && this.renderSection("CashFlowIfrsStatement", `Report.FinancialStatementsIfrs.${key.includes('Original') ? 'Original.' : ''}CashFlowStatement`,
                            data[key].cashFlowRows, data[key].headerTypes, data[key].statements, true)}
                    </div>
                </OldStyleSection>)}
                {Object.keys(data).some(key => data[key].hasFinancialPositionRows || data[key].hasProfitAndLossRows || data[key].hasCashFlowRows) &&
                    <ExcelExportButton link="fin-statements-ifrs" entityId={this.props.id} report={this.props.reportType} style={{marginBottom: '10px'}}/>}
            </>
        );
    }

    renderSection = (id, name, rows, headers, statements, from) => {
        return (
            <OldStyleSection name={this.props.translate(name)} isOpen isBold hasData={rows.length > 0}>
                <HorizontalScrollControl leftArrowMargin="13.4em">
                    <OldStyleTableWithHistory id={id} fixed={false} classNames={{ "fin-stmt-table-first": true }}
                        tableColumns={headers.length + statements.length + 1} stripped
                        head={() => this.renderHeaderRow(headers, statements, from)}
                        actualData={this.createRowData(rows)}
                        actualRow={(r) => this.renderDataRow(r)}
                    />
                </HorizontalScrollControl>
                {statements.filter(s => s.isIncorrect === true).length > 0 &&
                    <div className="fin-stmt-incorrect-legend">*&nbsp;<Translate id="Report.FinancialStatements.IncorrectLegend" /></div>}
            </OldStyleSection>
        );
    }

    renderHeaderRow = (headerTypes, statements, from) => {
        return (
            <thead>
                <tr>
                    <th className='col-sticky fin-stmt-w-10' style={{ left: "0" }}><Translate id="Report.FinancialStatements.ItemName" /></th>
                    {headerTypes.map((ht, index) => <th key={ht.typeId} className={classnames("col-sticky fin-stmt-w-5 fin-stmt-right", { "right-shadowed": (index === headerTypes.length - 1) })} style={{ left: `${10 + (index * 5)}em`, width: "5em" }}>({ht.marking})</th>)}
                    {statements.map(s =>
                        <th key={s.id} className="fin-stmt-right" style={{ width: "9.5em" }}>
                            {from ? <>{s.startDate}<br /></> : null}
                            {s.endDate}<br />
                            ({s.currency.toUpperCase()}) ({headerTypes.find(o => o.type === s.type).marking})
                            {s.isIncorrect ? <span className="fin-stmt-type-sk">&nbsp;*</span> : null}
                        </th>
                    )}
                </tr>
            </thead>
        );
    }

    renderDataRow = (r) => {
        return (
            <tr className={classnames("fin-stmt-row", { [`level-${r.level}`]: r.level !== undefined && r.level !== null })}>
                {r.data.map(d => <td key={d.key} className={d.className} style={{ left: (d.index !== undefined ? `${10 + (d.index * 5)}em` : '') }}>{d.value}</td>)}
            </tr>
        );
    }

    createRowData = (items) => {
        return [
            ...items.map(bs => ({
                level: bs.rowLevel, data: [
                    { key: `desc-${bs.rowId}`, value: bs.description, className: "col-sticky fin-stmt-w-10", index: -2 },
                    ...bs.types.map((t, index) => ({ key: t.rowId, value: t.value, className: "col-sticky fin-stmt-w-5 right-shadowed", index: index })),
                    ...bs.values.map(v => ({ key: v.rowId, value: v.value, className: classnames("fin-stmt-value", { "incorrect": v.incorrect, "inherit": !v.incorrect }) }))
                ]
            }))
        ];
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(FinStatementsIfrsData));